import { useAppConfig } from './appConfig.data.hooks'

/**
 * get platform logo (if any)
 */
export const usePlatformLogo = () => {
  const { data: appConfig } = useAppConfig()
  return appConfig?.platform?.logo
}

/**
 * get the platform name (if any)
 */
export const usePlatformName = () => {
  const { data: appConfig } = useAppConfig()
  return appConfig?.platform?.name
}
